



import Vue, { VueConstructor } from "vue";
import { findPos, rgbToHex } from "./color";
export interface Point {
  x: number;
  y: number;
}
interface Opts {
  $options: {
    ctx: CanvasRenderingContext2D;
  };
  $el: HTMLCanvasElement;
}
export default (Vue as VueConstructor<Vue & Opts>).extend({
  props: {
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 100
    }
  },
  watch: {
    width: "sizeChange",
    height: "sizeChange"
  },
  mounted() {
    this.$options.ctx = this.$el.getContext("2d") as CanvasRenderingContext2D;
    this.drawGrad();
  },
  methods: {
    sizeChange() {
      this.drawGrad();
      this.$nextTick(() => this.drawGrad());
    },
    drawGrad() {
      console.log("draw");
      const ctx = this.$options.ctx;
      const halfX = this.width * 0.5;
      const halfY = this.height * 0.5;

      // Create a rainbow.
      const spectrum = ctx.createLinearGradient(0, halfY, this.width, halfY);
      // spectrum.addColorStop(0, "#ff0000");
      // spectrum.addColorStop(0.17595203, "#ff6600");
      // spectrum.addColorStop(0.38311222, "#ffff00");
      // spectrum.addColorStop(0.60132098, "#00ff00");
      // spectrum.addColorStop(0.80571902, "#0000ff");
      // spectrum.addColorStop(1, "#800080");
      spectrum.addColorStop(0, "rgba(255,0,0,1)");
      spectrum.addColorStop(0.13, "rgba(255,102,0,1)");
      spectrum.addColorStop(0.26, "rgba(255,255,0,1)");
      spectrum.addColorStop(0.39, "rgba(0,255,0,1)");
      spectrum.addColorStop(0.52, "rgba(0,0,255,1)");
      spectrum.addColorStop(0.65, "rgba(128,0,128,1)");
      spectrum.addColorStop(0.78, "rgba(255,255,255,1)");
      spectrum.addColorStop(0.8, "rgba(255,242,224,1)");
      spectrum.addColorStop(0.84, "rgba(226,183,123,1)");
      spectrum.addColorStop(0.88, "rgba(198,134,66,1)");
      spectrum.addColorStop(0.92, "rgba(141,85,36,1)");
      spectrum.addColorStop(0.96, "rgba(107,63,25,1)");
      spectrum.addColorStop(1, "rgba(56,31,9,1)");

      // Create tints
      const tints = ctx.createLinearGradient(halfX, 0, halfX, this.height);
      tints.addColorStop(0, "rgba(255,255,255,1)");
      tints.addColorStop(0.5, "rgba(255,255,255,0)");
      tints.addColorStop(1, "rgba(0,0,0,1)");

      ctx.fillStyle = spectrum;
      ctx.fillRect(0, 0, this.width, this.height);
      ctx.fillStyle = tints;
      ctx.fillRect(0, 0, this.width, this.height);
    },
    getColor(viewportX: number, viewportY: number): string {
      const { x, y } = this.getLocal(viewportX, viewportY);
      return this.getColorLocal(x, y);
    },
    getColorLocal(x: number, y: number): string {
      const [r, g, b] = this.$options.ctx.getImageData(x, y, 1, 1).data;
      const hex = "#" + ("000000" + rgbToHex(r, g, b)).slice(-6);
      return hex;
    },
    clampLocalXY(x: number, y: number): Point {
      const pt: Point = { x, y };
      pt.x = pt.x < 0 ? 0 : pt.x;
      pt.x = pt.x > this.width ? this.width : pt.x;
      pt.y = pt.y < 0 ? 0 : pt.y;
      pt.y = pt.y > this.height ? this.height : pt.y;
      return pt;
    },
    getLocal(viewportX: number, viewportY: number): Point {
      const { x, y } = findPos(this.$el);
      return {
        x: viewportX - x,
        y: viewportY - y
      };
    }
  }
});
